import styled, { DefaultTheme } from "styled-components";

const quickCheckoutCustomStyles = (theme: DefaultTheme) => ({
    margin: `${theme.spacing.small} ${theme.spacing.medium} ${theme.spacing.empty} ${theme.spacing.medium}`,
    justifyContent: "flex-start",
});

export const Container = styled.div<{ isQuickCheckoutEnabled?: boolean }>(
    ({ theme, isQuickCheckoutEnabled = false }) => ({
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        height: "100%",
        margin: `${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.empty} ${theme.spacing.medium}`,
        ...(isQuickCheckoutEnabled && {
            ...quickCheckoutCustomStyles(theme),
        }),
    }),
);
